import { render, staticRenderFns } from "./MalwareDomains.vue?vue&type=template&id=c14dd288&"
import script from "./MalwareDomains.vue?vue&type=script&lang=js&"
export * from "./MalwareDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports